import React from "react";
import {
  Box,
  Button,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const TooltipPage = () => {
  return (
    <Paper elevation={0} sx={{ height: "100%" }}>
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
            Default Tooltip
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
            Tooltips display informative text when users hover over, focus on,
            or tap an element.
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>
          <PreviewAndEditor
            language="js"
            title={"Basic tooltip with arrow"}
            value={
              '                    <Tooltip title="Delete" placement={"left"} open>\n' +
              "                            <Button>Click</Button>\n" +
              "                        </Tooltip>\n\n\n" +
              '                        <Tooltip title="Delete" placement={"top"} open>\n' +
              "                            <Button>Click</Button>\n" +
              "                        </Tooltip>\n\n\n" +
              '                        <Tooltip title="Delete" placement={"bottom"} open>\n' +
              "                            <Button>Click</Button>\n" +
              "                        </Tooltip>\n\n\n" +
              '                        <Tooltip title="Delete" placement={"right"} open>\n' +
              "                            <Button>Click</Button>\n" +
              "                        </Tooltip>"
            }
          >
            <Tooltip title="Delete" placement={"left"} open>
              <Button>Click</Button>
            </Tooltip>
            <Tooltip title="Delete" placement={"top"} open>
              <Button>Click</Button>
            </Tooltip>
            <Tooltip title="Delete" placement={"bottom"} open>
              <Button>Click</Button>
            </Tooltip>
            <Tooltip title="Delete" placement={"right"} open>
              <Button>Click</Button>
            </Tooltip>
          </PreviewAndEditor>
        </Box>
      </Stack>
    </Paper>
  );
};

export default TooltipPage;